{
  "title": "Application Mobile",
  "description": "Gérer les versions et les liens de l'application mobile",
  "iosVersion": "Version iOS",
  "androidVersion": "Version Android",
  "iosStoreUrl": "URL App Store",
  "androidStoreUrl": "URL Play Store",
  "edit": "Modifier",
  "editDialog": {
    "title": "Modifier {{field}}",
    "description": "Êtes-vous sûr de vouloir modifier cette valeur ?",
    "currentValue": "Valeur actuelle : {{value}}",
    "newValue": "Nouvelle valeur",
    "cancel": "Annuler",
    "confirm": "Confirmer"
  },
  "success": {
    "updated": "Version de l'application mise à jour avec succès"
  },
  "errors": {
    "fetchFailed": "Impossible de récupérer la version de l'application",
    "updateFailed": "Impossible de mettre à jour la version de l'application"
  }
}
